/**
 * Utility function to generate unique IDs
 *
 * This function generates a random string ID that can be used
 * for temporary IDs in forms and components before they are
 * saved to the database.
 */

export const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};
